<template>
    <x-page title="Edit Pertemuan">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <gathering-form id="gathering-form"
            v-if="Boolean(resource)"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource" />
        <template #footer>
            <x-submit-button form="gathering-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { formatForDateInput, handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import GatheringForm from './GatheringForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        GatheringForm,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/gatherings/${this.$route.params.id}`, {
                params: {
                    load: [
                        'attendants',
                    ],
                }
            })
            .then(response => {
                const resource = response.data.data
                this.resource = { 
                    ...resource,
                    date: formatForDateInput(resource.date),
                    member_ids: resource.attendants.map(attendant => attendant.id),
                }
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.put(`/api/gatherings/${this.$route.params.id}`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.date} updated!`,
                    })
                    this.$router.back()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
                this.isLoading = false
            })
        },
    },
}
</script>